var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilestoneFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 9.99967C2.6665 9.99967 3.33317 9.33301 5.33317 9.33301C7.33317 9.33301 8.6665 10.6663 10.6665 10.6663C12.6665 10.6663 13.3332 9.99967 13.3332 9.99967V1.99967C13.3332 1.99967 12.6665 2.66634 10.6665 2.66634C8.6665 2.66634 7.33317 1.33301 5.33317 1.33301C3.33317 1.33301 2.6665 1.99967 2.6665 1.99967V9.99967Z",
    stroke: "#6F3FF5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 14.6667V10",
    stroke: "#6F3FF5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneFlag);
export default __webpack_public_path__ + "static/media/milestone-flag.4a443877219f2c4f203b389544d410ae.svg";
export { ForwardRef as ReactComponent };